/**
 * Created by tan-qui on 2024/05/24
 */
import { Result } from "antd";
import { Component } from "react";

class PageNotFound extends Component {
  render() {
    return (
      <Result
        status="404"
        title="404"
      />
    );
  }
};

export default PageNotFound;
